import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import { CovidTestSlugs } from '../../util';
import { getAssociatedTelemedLocationId, isBookable } from '../../../../../../core/util/location';
import { colors } from '../../../../../../constants/colors';
import { LocationContext } from '../../../../ContextProviders';
import { isMobile } from '../../../../../../core/util/device';
import { analyticsTrackEvent } from '../../../../../../core/analytics';
import {
  CDP_COVID_TEST_ACTIONS,
  CDP_COVID_TEST_SECTION,
} from '../../../../../../core/analytics/events';
import { StyledBody } from '../../CSSstyles';
import { useStartBooking } from '~/components/ClinicDetailPageFlexible/hooks/useStartBooking';

const BookAVisit = styled.span.withConfig({ componentId: 'sc-1mzo8d1-0' })`
  color: ${colors.link};
  cursor: pointer;
`;

type Props = {
  requirements?: any[];
  testType: string;
};

const GetStartedBulletPoint = (props: Props) => {
  const { requirements, testType } = props;
  const {
    location,
    location: { id, uclId },
  } = useContext(LocationContext);
  const startBooking = useStartBooking();

  const shouldPromptVideoVisit =
    !isEmpty(getAssociatedTelemedLocationId(location)) &&
    requirements?.includes('Video Visit Screening');

  const getStartedCopy = useMemo(() => {
    const handleBookAVisitClick = () => {
      startBooking(shouldPromptVideoVisit);

      const trackingProperties = {
        action: shouldPromptVideoVisit
          ? CDP_COVID_TEST_ACTIONS.CLICK_BOOK_A_VIDEO_VISIT
          : CDP_COVID_TEST_ACTIONS.CLICK_BOOK_A_VISIT,
        locationId: id,
        uclId,
      };
      analyticsTrackEvent(CDP_COVID_TEST_SECTION, trackingProperties);
    };

    const prefaceCopy =
      shouldPromptVideoVisit || (requirements?.length && requirements.length > 1)
        ? 'To get started, '
        : 'To schedule a test, ';
    const bookAVisitCopy = `book a${shouldPromptVideoVisit ? ' video' : ''} visit`;
    const reasonForVisit =
      testType === CovidTestSlugs.COVID_TEST ? '"COVID test"' : '"COVID antibody test"';
    const shouldMakeBookVisitCopyALink = isMobile() || shouldPromptVideoVisit;
    const bookAVisit = shouldMakeBookVisitCopyALink ? (
      <BookAVisit onClick={handleBookAVisitClick}>{bookAVisitCopy}</BookAVisit>
    ) : (
      bookAVisitCopy
    );

    return (
      <span>
        {prefaceCopy}
        {bookAVisit} with&nbsp;{reasonForVisit} as your reason for visit.
      </span>
    );
  }, [id, requirements?.length, shouldPromptVideoVisit, startBooking, testType, uclId]);

  if (!isBookable(location)) return null;

  return (
    <li>
      <StyledBody>{getStartedCopy}</StyledBody>
    </li>
  );
};

export default GetStartedBulletPoint;
